/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { fromAbsolute, getLocalTimeZone } from '@internationalized/date';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import merge from 'lodash/merge';

import {
    CLEAR_LOTTERY_APPLICATION_ERROR,
    DUPLICATED_LOTTERY_APPLICATION,
    FETCH_USER_APPLICATION_STATUS_COMPLETE,
    FETCH_USER_APPLICATION_STATUS_ERROR,
    LOADING_USER_APPLICATION_STATUS,
    LOTTERY_APPLICATION_IN_CART,
} from '../constants/earlyAccessLottery';

const initialState = {
    errors: {},
    lotteries: {
        byLotteryId: {},
        byApplicationId: {},
    },
};

export default function earlyAccessLotteryReducer(state = initialState, action) {
    const newState = merge({}, state);

    switch (action.type) {
        case CLEAR_LOTTERY_APPLICATION_ERROR: {
            newState.errors = {};

            return newState;
        }
        case DUPLICATED_LOTTERY_APPLICATION: {
            newState.errors = {
                duplicated: true,
            };

            return newState;
        }
        case LOTTERY_APPLICATION_IN_CART: {
            newState.errors = {
                inCart: true,
            };

            return newState;
        }
        case FETCH_USER_APPLICATION_STATUS_COMPLETE: {
            const payload = action.payload;

            if (payload.application_id) {
                newState.lotteries.byApplicationId = {
                    ...newState.lotteries.byApplicationId,
                    [payload.application_id]: {
                        id: action.payload.application_id,
                        hasApplied: get(payload, 'has_applied', false),
                        loading: false,
                        isWinner: get(payload, 'is_winner', false),
                        assignedTimeSlot: null,
                    },
                };
            }

            if (payload.lotteryId) {
                newState.lotteries.byLotteryId = {
                    ...newState.lotteries.byLotteryId,
                    [payload.lotteryId]: {
                        applicationId:
                            (!isNil(payload.application_id) && payload.application_id) ||
                            null,
                        assignedTimeSlot: null,
                        hasApplied: get(payload, 'has_applied', false),
                        loading: false,
                        id: payload.lotteryId,
                        isWinner: get(payload, 'is_winner', false),
                    },
                };

                if (newState.lotteries.byLotteryId[payload.lotteryId]?.isWinner) {
                    const unixTimestamp = get(payload, 'start_time.seconds', null);
                    let assignedTimeSlot = null;
                    if (unixTimestamp) {
                        const date = fromAbsolute(
                            unixTimestamp * 1000,
                            getLocalTimeZone()
                        );
                        assignedTimeSlot = date.toAbsoluteString();
                    }
                    newState.lotteries.byLotteryId[payload.lotteryId].assignedTimeSlot =
                        assignedTimeSlot;
                }
            }
            return newState;
        }

        case FETCH_USER_APPLICATION_STATUS_ERROR: {
            const payload = action.payload;
            if (payload.lotteryId) {
                newState.lotteries.byLotteryId = {
                    ...newState.lotteries.byLotteryId,
                    [payload.lotteryId]: {
                        applicationId: null,
                        assignedTimeSlot: null,
                        hasApplied: false,
                        loading: false,
                        id: payload.lotteryId,
                        isWinner: false,
                    },
                };
            }

            return newState;
        }
        case LOADING_USER_APPLICATION_STATUS: {
            newState.lotteries = {
                ...newState.lotteries,
                byApplicationId: {
                    ...newState.lotteries.byApplicationId,
                },
                byLotteryId: {
                    ...newState.lotteries.byLotteryId,
                    [action.payload.lotteryId]: {
                        applicationId: '',
                        id: action.payload.lotteryId,
                        assignedTimeSlot: null,
                        hasApplied: false,
                        isWinner: false,
                        loading: true,
                    },
                },
            };

            if (action.payload.application_id) {
                newState.lotteries.byApplicationId = {
                    ...newState.lotteries.byApplicationId,
                    [action.payload.application_id]: {
                        applicationId: action.payload.application_id,
                        lotteryId: '',
                        assignedTimeSlot: get(action.payload.start_time, 'seconds', null),
                        hasApplied: true,
                        isWinner: get(action.payload, 'is_winner', false),
                        loading: true,
                    },
                };
            }

            return newState;
        }
        default:
            return newState;
    }
}
